import axios from "axios";
import React, { useState, useEffect } from "react";
import { Col, Row, Button, Label, Input } from "reactstrap";
import { useHistory } from "react-router-dom";
import { UserConsumer } from "../../../UserContext";
import { ItemRequisitionAPI } from "../ItemRequisitionAPI";
import { AlertPopups } from "../../../components/AlertPopups";
import PersonalInfo from "./PersonalInfo";
import CustomReactSelect from "../../../components/CustomReactSelect";
import FormStatus from "../../../components/FormStatus";

function SSNCreateItemRequisition() {
	let token = null;
	const history = useHistory();
	const initialValues = {
		projectName: "",
		itemName: "",
		reqPriority: "",
		description: "",
		justification: "",
	};
	const [formRequestFields, setFormRequestFields] = useState(initialValues);
	const [currentUser, setCurrentUser] = useState(null);
	const [apiHeaderToken, setApiHeaderToken] = useState(null);
	const [requestPriorityList, setRequestPriorityList] = useState(null);
	useState(null);
	const [selectedRequestPriority, setSelectedRequestPriority] =
		useState(null);

	useEffect(() => {
		const tokenHeader = {
			Authorization: `Bearer ${token}`,
		};
		axios
			.get(`${ItemRequisitionAPI.GetEmployeeInfo}`, {
				headers: tokenHeader,
			})
			.then(({ status, data }) => {
				if (status === 200) {
					setCurrentUser(data);
				}
			});

		axios
			.get(`${ItemRequisitionAPI.GetReqPriorityList}`, {
				headers: tokenHeader,
			})
			.then(({ status, data }) => {
				if (status === 200) {
					setRequestPriorityList(data.priorities);
				}
			});

		setApiHeaderToken(tokenHeader);
	}, []);

	const handleChange = (event, displayCode) => {
		if (displayCode === 1)
			setFormRequestFields({
				...formRequestFields,
				[event.target.name]: event.target.value,
			});
	};

	const createItemRequisitionApplication = () => {
		const formbody = {
			...formRequestFields,
			["priority"]: selectedRequestPriority.value,
		};
		axios
			.post(`${ItemRequisitionAPI.PostItemRequisition}`, formbody, {
				headers: apiHeaderToken,
			})
			.then(({ status }) => {
				if (status === 200) {
					history.push("/ItemRequisition");
					AlertPopups.successAlert.fire({
						text: "Item Requested",
					});
				} else {
					AlertPopups.ErrorAlert.fire({
						text: "Item Request Error",
					});
				}
			})
			.catch((err) => {
				if (err.response) {
					AlertPopups.ErrorAlert.fire({
						text: `${err.response.data.message}`,
					});
				} else
					AlertPopups.ErrorAlert.fire({
						text: "Item Request Error",
					});
			});
	};

	return (
		<UserConsumer>
			{(userDetails) => {
				token = userDetails.token;
				return (
					<>
						<div className="container-fluid pl-3 pr-3">
							<Row className=" mb-3">
								<Col
									className="justify-content-between"
									lg={12}
								>
									<FormStatus
										formStatus={"Draft"}
										className="create-request d-flex align-items-center"
										onClick={() => {
											history.push("/ItemRequisition");
										}}
										navigateBack={true}
									/>
								</Col>
							</Row>
							<PersonalInfo currentUser={currentUser} />

							<div className=" my-4 formInfoContainer">
								<div className="formInfoContainerHeader">
									<Label sm={12}>Request Details</Label>
								</div>

								<Row className="py-2 px-4">
									<Col md={12} lg={3}>
										<div className="formDetailHeader">
											<div>Project Name</div>
										</div>
									</Col>
									<Col md={12} lg={3}>
										<Input
											type="text"
											name="projectName"
											id="projectName"
											onChange={(value) =>
												handleChange(value, 1)
											}
											value={
												formRequestFields.projectName
											}
											maxLength="500"
										/>
									</Col>
									<Col md={12} lg={3}>
										<div className="formDetailHeader">
											<div>Item</div>
										</div>
									</Col>
									<Col md={12} lg={3}>
										<Input
											type="text"
											name="itemName"
											id="itemName"
											maxLength="500"
											onChange={(value) =>
												handleChange(value, 1)
											}
											value={formRequestFields.itemName}
										/>
									</Col>
									<Col
										md={12}
										lg={3}
										className="mt-3 mb-0 pb-0"
									>
										<div className="formDetailHeader">
											<div>Req.Priority</div>
										</div>
									</Col>
									<Col
										md={12}
										lg={3}
										className="mt-3 mb-0 pb-0"
									>
										<CustomReactSelect
											value={selectedRequestPriority}
											options={requestPriorityList}
											onChange={(value) =>
												setSelectedRequestPriority(
													value
												)
											}
										/>
									</Col>
									<Col
										md={12}
										lg={3}
										className="mt-3 mb-0 pb-0"
									>
										<div className="formDetailHeader">
											<div>Description</div>
										</div>
									</Col>
									<Col
										md={12}
										lg={3}
										className="mt-3 mb-0 pb-0"
									>
										<Input
											type="textarea"
											maxLength="400"
											name="description"
											id="description"
											onChange={(value) =>
												handleChange(value, 1)
											}
											value={
												formRequestFields.description
											}
										/>
									</Col>
									<Col md={12} lg={3} className="my-0 py-0">
										<div className="formDetailHeader">
											<div>Please justify the need</div>
										</div>
									</Col>
									<Col md={12} lg={3} className="my-0 py-0">
										<Input
											type="textarea"
											name="justification"
											id="justification"
											onChange={(value) =>
												handleChange(value, 1)
											}
											value={
												formRequestFields.justification
											}
											maxLength="400"
										/>
									</Col>
								</Row>
							</div>

							<div className="btns">
								<Button
									className="submit-btn"
									onClick={createItemRequisitionApplication}
								>
									Submit
								</Button>
							</div>
						</div>
					</>
				);
			}}
		</UserConsumer>
	);
}

export default SSNCreateItemRequisition;
